/* HYA 2026-09-18: one consistent "Product Details" label above the selling-facts list in the Details accordion. */
/* Descriptions that carry their own inline heading have it removed so the label never doubles up. */
(function () {
function run() {
document.querySelectorAll('.product-details details').forEach(function (d) {
var summary = d.querySelector('summary');
if (!summary || summary.textContent.trim().toLowerCase() !== 'details') return;
var list = d.querySelector('ul');
if (!list) return;
var prev = list.previousElementSibling;
if (prev && prev.className === 'hya-pd-label') return;
d.querySelectorAll('b, strong').forEach(function (b) { if (b.textContent.trim().toUpperCase().indexOf('PRODUCT DETAILS') === 0) b.remove(); });
var label = document.createElement('p');
label.className = 'hya-pd-label';
label.textContent = 'Product Details';
list.parentNode.insertBefore(label, list);
});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
document.addEventListener('shopify:section:load', run);
})();